import type { App } from 'vue'
import de from 'element-plus/es/locale/lang/de'
import en from 'element-plus/es/locale/lang/en'

let appInstance: App | null = null

// Store app instance for later use
export const setElementPlusApp = (app: App) => {
  appInstance = app
}

// Get the ElementPlus locale based on language code
export const getElementPlusLocale = (language: string) => {
  const localeMap: { [key: string]: any } = {
    de: de,
    en: en,
  }
  return localeMap[language] || en
}

// Update ElementPlus locale dynamically
export const updateElementPlusLocale = (language: string) => {
  const locale = getElementPlusLocale(language)
  
  // Update ElementPlus locale through the global config
  if (appInstance) {
    appInstance.config.globalProperties.$ELEMENT = {
      locale: locale,
    }
  }
}
